/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Prev1Inputs */

const vi_cmspost_prev1 = /** @type {(inputs: Cmspost_Prev1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trước`)
};

/**

* @param {Cmspost_Prev1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_prev1 = /** @type {((inputs?: Cmspost_Prev1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Prev1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_prev1(inputs)
});
export { cmspost_prev1 as "cmsPost_prev" }